<ng-container *ngIf="!loading else spinnerBlock">
    <div class="contest-lessons__wrapper">
        <app-contest-header *ngIf="canCompete"
                            [contest]="contest">
        </app-contest-header>
        <div class="contest-lessons__content"
             [ngClass]="{'contest-lessons__content--border-radius': !canCompete}">
            <mat-tab-group class="contest-lessons__tab-group"
                           (selectedIndexChange)="onTabChange($event)">
                <mat-tab *ngFor="let subLesson of subLessons"
                         label="{{ subLesson?.get('metadatas')?.title }}">
                    <ul class="contest-lessons__list">
                        <li *ngFor="let activity of activities[subLesson.id]; index as i"
                            class="contest-lessons__item">
                            <app-activty-card class="contest-lessons__card"
                                              [isActivitiesIsDone]="isActivityDone(activity)"
                                              [title]="activity.get('metadatas').title"
                                              [image]="getActivityTypeImage(activity)"
                                              [subLesson]="subLesson"
                                              [i]="i"
                                              (playEvent)="playEvent($event)">
                            </app-activty-card>
                        </li>
                    </ul>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</ng-container>

<ng-template #spinnerBlock>
    <div class="contest-lessons__spinner-wrapper">
        <mat-spinner></mat-spinner>
    </div>
</ng-template>